import { OfferCardTypeEnum } from '@wwe-portal/entities/offer.type';
import { cn } from '@wwe-portal/ui/lib/lib';
import logoWebp from '@wwe-portal/ui/assets/images/flagship/logo.webp';

export const SoldOut = ({ type }: { type: OfferCardTypeEnum }) => {
  return (
    <div
      className={cn(
        'bg-back300 flex h-full w-full flex-row items-center justify-center gap-1',
        {
          'flex-col': OfferCardTypeEnum.SINGLE3 === type,
        }
      )}
    >
      <div className="absolute inset-0 bg-black" style={{ opacity: 0.65 }} />
      <div className="bg-back400 absolute inset-0" style={{ opacity: 0.8 }}>
        <div className="flex h-full flex-col justify-center gap-y-2 space-y-4 px-4 py-8">
          <img
            alt="logo"
            className="mx-auto h-[32px] w-[50px] text-center"
            src={logoWebp}
          />
          <span className="text-text500 mx-auto text-center text-xl font-bold">
            SOLD OUT
          </span>
        </div>
      </div>
    </div>
  );
};
